/**
 * Maps language codes to human-readable language names for ChatGPT
 */

const LANGUAGE_CODE_TO_NAME: Record<string, string> = {
  'en-us': 'English',
  'fr-ca': 'French',
  'es': 'Spanish',
  'sk': 'Slovak',
  // Add more as needed
};

/**
 * Converts a language code (e.g., "fr-ca") to a human-readable name (e.g., "French")
 * for use in ChatGPT system prompts
 */
export function getLanguageNameForChatGPT(languageCode: string | undefined): string | undefined {
  if (!languageCode) {
    return undefined;
  }
  
  const normalized = languageCode.toLowerCase();
  return LANGUAGE_CODE_TO_NAME[normalized];
}

